import Axios from "axios";
import { API } from "../constants/api";
const axios = Axios.create();

let injectedLogout: any = null;
let isLoggingOut = false;
export const injectLogout = (logoutFn: any) => {
  injectedLogout = logoutFn;
};

// Setup request interceptor
axios.interceptors.request.use(
  function (config) {
    config.withCredentials = true;
    config.headers["x-client-type"] = "web";
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Setup response interceptor
// axios.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     if (error.response?.status === 401 && injectedLogout) {
//       await injectedLogout(); // Call your logout with type
//     }
//     return Promise.reject(error);
//   }
// );

// Setup response interceptor
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    console.log("Interceptor fired", error.response?.status);

    if (
      error.response?.status === 401 &&
      injectedLogout &&
      !isLoggingOut
    ) {
      console.log("Calling injected logout");

      isLoggingOut = true;

      injectedLogout();

      return Promise.reject(error);   // <-- important
    }

    return Promise.reject(error);
  }
);

export const POST_AUTH_LOGIN_SESSION_KEY = () =>
  axios.post(API.AUTH_LOGIN_SESSION_KEY);
export const POST_AUTH_LOGIN = (body: any) => axios.post(API.AUTH_LOGIN, body);
export const POST_AUTH_LOGOUT = (body: any) =>
  axios.post(API.AUTH_LOGOUT, body);
export const GET_TEMPLATE = async (params: any) =>
  await axios.get(`${API.TEMPLATE}?${params}`);
export const GET_TEMPLATES_BY_USER_ID = async (userId: any, params: any) =>
  await axios.get(`${API.TEMPLATE}/${userId}?${params}`);
export const POST_TEMPLATE_PUBLISH = async (body: any) =>
  await axios.post(API.TEMPLATE_PUBLISH, body);
export const PUT_TEMPLATE = async (body: any) =>
  await axios.put(API.TEMPLATE, body);
export const POST_TEMPLATE_DELETE = async (body: any) =>
  await axios.post(API.TEMPLATE_DELETE, body);
export const GET_TEMPLATE_BY_SEARCH = async (params: any, controller: any) =>
  await axios.get(`${API.TEMPLATE_SEARCH}?${params}`, {
    signal: controller.signal,
  });
export const GET_CATEGORY = async () => await axios.get(API.CATEGORY);

export const PUT_USER = async (body: any) =>
  await axios.put(API.USER, body, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
export const GET_HOLDER = async (params: any) =>
  await axios.get(`${API.HOLDER}?${params}`);

export const POST_VCS = async (body: any) =>
  axios.post(`${API.VCS_PREPARE}`, body);

export const POST_VCS_COMPLETE = async (body: any) =>
  axios.post(`${API.VCS_COMPLETE}`, body);
// export const POST_VCS = async (body, accessToken) =>
//   axios.post(`${API.VCS}`, body, {
//     headers: {
//       "Access-Token": accessToken,
//     },
//   });

export const GET_ISSUER_DASHBOARD_SUMMARY = async (params: any) =>
  await axios.get(`${API.ISSUER_DASHBOARD_SUMMARY}?${params}`);
export const GET_ISSUER_USERS = async (params: any) =>
  await axios.get(`${API.ISSUER_USERS}?${params}`);
export const GET_ISSUER_CREDENTIALS_BY_DEPT = async (params: any) =>
  await axios.get(`${API.ISSUER_CREDENTIALS_BY_DEPT}?${params}`);
export const GET_ISSUER_CREDENTIALS_BY_TYPE = async (params: any) =>
  await axios.get(`${API.ISSUER_CREDENTIALS_BY_TYPE}?${params}`);
export const GET_ISSUER_ANALYTICS_SUMMARY = async (params: any) =>
  await axios.get(`${API.ISSUER_ANALYTICS_SUMMARY}?${params}`);
export const GET_ISSUER_ANALYTICS_CHART = async (params: any) =>
  await axios.get(`${API.ISSUER_ANALYTICS_CHART}?${params}`);
export const GET_ISSUER_ORGANIZATION = async () =>
  await axios.get(`${API.ISSUER_ORGANIZATION}`);
export const GET_ADMIN_ANALYTICS_SUMMARY = async (params: any) =>
  await axios.get(`${API.ADMIN_ANALYTICS_SUMMARY}?${params}`);
export const GET_ISSUER_DASHBOARD_TABLE = async (params: any) =>
  await axios.get(`${API.ISSUER_DASHBOARD_TABLE}?${params}`);
export const GET_DEPARTMENT = async (params: any) =>
  await axios.get(`${API.DEPARTMENT}?${params}`);
// export const GET_DASHBOARD_SUMMARY = async (params: any) =>
//   await axios.get(`${API.DASHBOARD_SUMMARY}?${params}`);
export const GET_TEMPLATE_VCS = (params: any) =>
  axios.get(`${API.TEMPLATE_VC}?${params}`);
export const GET_TEMPLATE_VP = (params: any) =>
  axios.get(`${API.TEMPLATE_VP}?${params}`);
export const POST_TEMPLATE_VP = (body: any) =>
  axios.post(API.TEMPLATE_VP, body);
export const POST_VCS_REVOKE = (body: any) => axios.post(API.VCS_REVOKE, body);
export const GET_VERIFIER_ANALYTICS_SUMMARY = async (params: any) =>
  await axios.get(`${API.VERIFIER_ANALYTICS_SUMMARY}?${params}`);
export const GET_VERIFIER_DASHBOARD_CHART = async (params: any) =>
  await axios.get(`${API.VERIFIER_DASHBOARD_CHART}?${params}`);
export const GET_VERIFIER_ANALYTICS_CHART = async (params: any) =>
  await axios.get(`${API.VERIFIER_ANALYTICS_CHART}?${params}`);

export const POST_VP_REQUEST = (body: any, accessToken: any) =>
  axios.post(`${API.VP_REQUEST}`, body, {
    headers: {
      "Access-Token": accessToken,
    },
  });
export const GET_ALL_VERIFICATIONS = async (params: any) =>
  await axios.get(`${API.VP_REQUEST}?${params}`);

export const POST_FORGOT_PASSWORD = (body: any) =>
  axios.post(API.FORGOT_PASSWORD, body);
// export const Post_RESET_PASSWORD = (body, tokken) => axios.post(API.RESET_PASSWORD, body, {
//     headers : {Authorization : `Bearer ${tokken}`}
// })
export const Post_RESET_PASSWORD = (body: any, tokken: any) =>
  axios.post(API.RESET_PASSWORD, body);
export const VERIFY_OTP = (body: any) => axios.post(API.AUTH_OTP, body);
export const POST_RESEND_OTP = () => axios.post(API.RESEND_OTP);
export const TOGGLE_2FA = (params: any) =>
  axios.put(`${API.USER}/${params}-2fa`);

export const ADD_USER = async (body: any, accessToken: any) =>
  await axios.post(API.USER, body, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Access-Token": accessToken,
    },
  });
export const UPDATE_USER = async (body: any) =>
  await axios.put(API.USER, body, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
export const UPDATE_USER_STATUS = async (body: any) =>
  axios.put(`${API.USER}/${body.userId}/${body.status}`);
export const GET_ADMIN_USER_CHART = async (params: any) =>
  await axios.get(`${API.ADMIN_USER_CHART}?${params}`);
export const GET_USERS_ADMIN = async (params: any) =>
  await axios.get(`${API.USER_ADMIN}?${params}`);
export const GET_ADMIN_HOLDERS_CHART = async (params: any) =>
  await axios.get(`${API.ADMIN_HOLDERS_CHART}?${params}`);
export const GET_ADMIN_DASHBOARD_TABLE = async (params: any) =>
  await axios.get(`${API.ADMIN_DASHBOARD_TABLE}?${params}`);
export const GET_ADMIN_USER_DETAILS_ANALYTICS = async (
  userId: any,
  params: any
) => axios.get(`${API.USER}/${userId}?${params}`);

export const POST_ADMIN_WEBHOOK = (body: any) =>
  axios.post(API.ADMIN_WEBHOOK, body);

export const GET_ADMIN_WEBHOOK = async (params: any) =>
  await axios.get(`${API.ADMIN_WEBHOOK_TABLE}?${params}`);
export const GET_USER_VCS_BY_TYPE = ({ params, userId, type }: any) =>
  axios.get(`${API.VCS}/${type}/${userId}?${params}`);
export const POST_DAPP_KEY = (body: any) => axios.post(API.DAPP, body);
export const GET_USER_VPS = ({ userId, params }: any) =>
  axios.get(`${API.VP}/${userId}?${params}`);

export const PUT_ADMIN_DELETE_WEBHOOK = async (body: any, id: any) =>
  await axios.put(`${API.ADMIN_DELETE_WEBHOOK}/${id}/delete`, body);

export const PUT_ADMIN_ACTIVATE_WEBHOOK = async (body: any, id: any) =>
  await axios.put(`${API.ADMIN_ACTIVATE_WEBHOOK}/${id}/activate`, body);

export const PUT_ADMIN_DEACTIVATE_WEBHOOK = async (body: any, id: any) =>
  await axios.put(`${API.ADMIN_DEACTIVATE_WEBHOOK}/${id}/deactivate`, body);

export const GET_DAPP_KEYS = (params: any) =>
  axios.get(`${API.DAPP}?${params}`);
export const UPDATE_DAPP_KEY = (body: any) =>
  axios.put(`${API.DAPP_UPDATE}`, body);
export const DELETE_DAPP_KEY = (body: any) =>
  axios.put(`${API.DAPP}/delete`, body);
export const PUT_ORGANIZATION = (body: any) =>
  axios.put(API.ORGANIZATION, body);
export const GET_ANALYTICS_ADMIN_CHART_DATA = (params: any) =>
  axios.get(`${API.ANALYTICS_ADMIN_CHART_DATA}?${params}`);
export const GET_ANALYTICS_ADMIN = (params: any) =>
  axios.get(`${API.ANALYTICS_ADMIN}?${params}`);
export const GET_USER_SUPER_ADMIN = (params: any) =>
  axios.get(`${API.USER_SUPER_ADMIN}?${params}`);
export const UPDATE_ORGANIZATION_BY_ID = (id: any, body: any) =>
  axios.put(`${API.USER}/${id}`, body);
export const GET_SUPERADMIN_VC_CHART = (params: any) =>
  axios.get(`${API.SUPERADMIN_VC_CHART}?${params}`);
export const GET_SUPERADMIN_VP_CHART = (params: any) =>
  axios.get(`${API.SUPERADMIN_VP_CHART}?${params}`);
export const GET_ANALYTICS_SUPER_ADMIN_CHART_DATA = (params: any) =>
  axios.get(`${API.ANALYTICS_SUPER_ADMIN_CHART_DATA}?${params}`);
export const GET_ANALYTICS_SUPER_ADMIN = (params: any) =>
  axios.get(`${API.ANALYTICS_SUPER_ADMIN}?${params}`);
export const GET_CHECK_ORG_NAME_OR_EMAIL = (params: any) =>
  axios.get(`${API.CHECK_ORG_NAME_OR_EMAIL}?${params}`);
export const GET_SUPERADMIN_ANALYTICS_SUMMARY = (params: any) =>
  axios.get(`${API.SUPERADMIN_ANALYTICS_SUMMARY}?${params}`);
// export const POST_AUTH_KMS_DECRYPTION = (body, axiosConfig) =>
//   axios.post(`${API.AUTH_KMS_DECRYPTION}`, body, axiosConfig);
// export const POST_AUTH_KMS_ENCRYPTION = (body, axiosConfig) =>
//   axios.post(`${API.AUTH_KMS_ENCRYPTION}`, body, axiosConfig);
export const GET_VP_QR = (vpId: any) => axios.get(`${API.VP_QR}/${vpId}`);
export const POST_VP_VERIFY = (body: any) => axios.post(API.VP_VERIFY, body);
export const GET_ISSUED_BY = () => axios.get(`${API.ISSUED_BY}`);
export const GET_ORGANIZATION_TEMPLATE = (params: any) =>
  axios.get(`${API.ORGANIZATION_TEMPLATE}/${params}`);
export const GET_ISSUER = (params: any) => axios.get(`${API.ISSUER}?${params}`);

export const POST_CREATE_DID_REQUEST = (body: any) =>
  axios.post(`${API.CREATE_DID_REQUEST}`, body);
export const POST_SUBMIT_DID_REQUEST = (body: any) =>
  axios.post(`${API.SUBMIT_DID_REQUEST}`, body);
export const GET_HOLDER_SHARED_CREDENTIALS = (id: any) =>
  axios.get(`${API.HOLDER_SHARED_CREDENTIALS}/${id}`);
export const GET_VERIFY_CREDENTIAL = (vcId: any, params: any) =>
  axios.get(`${API.VERIFY_CREDENTIAL}/${vcId}?${params}`);

//Certificate
export const GET_ALL_ASSETS = (params: any) =>
  axios.get(`${API.GET_ALL_ASSETS}?${params}`);

export const GET_ALL_VARIABLES = () => axios.get(`${API.GET_ALL_VARIABLES}`);

export const UPLOAD_ASSETS = (body: any) =>
  axios.post(`${API.UPLOAD_ASSETS}`, body, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
export const SAVE_DESIGNS = (body: any) =>
  axios.post(`${API.SAVE_DESIGNS}`, body);

export const GET_ALL_DESIGNS = (param: any) =>
  axios.get(`${API.SAVE_DESIGNS}?${param}`);

export const GET_TOKEN_VERIFICATION = (param: any, token: any) =>
  axios.get(`${API.TOKEN_VERIFICATION}?${param}`, {
    headers: {
      Authorization: `${token}`,
    },
  });

export const GET_PUBLIC_KEY = (param: any) =>
  axios.get(`${API.GET_PUBLICKEY}?${param}`);

export const GET_TEMPLATE_BY_ID = (id: any) =>
  axios.get(`${API.TEMPLATE}/id/${id}`);

export const GET_HOLDER_ONBOARDING = (params: any) =>
  axios.get(`${API.HOLDER_ONBOARDING}?${params}`);
export const POST_HOLDER_ONBOARDING = (body: any) =>
  axios.post(`${API.HOLDER_ONBOARDING}`, body, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
export const POST_HOLDER_ONBOARDING_RESEND = (body: any) =>
  axios.post(`${API.HOLDER_ONBOARDING_RESEND}`, body);

export const POST_POW_UPLOAD = (body: any) =>
  axios.post(`${API.POW_UPLOAD}`, body, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const GET_ALL_FILES = (params: any) =>
  axios.get(`${API.GET_ALL_FILES}?did=${params}`);

export const GET_ALL_FILES_BY_ID = (vcId: any) =>
  axios.get(`${API.GET_ALL_FILES_BY_ID}/${vcId}/files`);

export const DELETE_CERTIFICATE = (body: { designIds: string[] | number[] }) =>
  axios.delete(`${API.SAVE_DESIGNS}`, { data: body });

